import { Icon } from '@livable/saas-react-components';
import React from 'react';
import { hasOverlappingBills, isAwaitingSpikeReview } from 'src/components/allocations/AllocationSuggestion';
import { formatUtilityLabel, getUtilityIconType } from 'src/pages/NewBillingModule/ApplyBillingFull/BillAutomationExtraction';
import useStyles from './billDetailsStyles';

/**
 * Vertical utility switcher on the left of a line items / allocation table body. The status dot, which
 * only the allocation tables show, marks a utility as allocated or as one whose dates are already billed.
 */
export function UtilityRail(_ref) {
  let activeIndex = _ref.activeIndex,
    onChange = _ref.onChange,
    _ref$showStatus = _ref.showStatus,
    showStatus = _ref$showStatus === void 0 ? false : _ref$showStatus,
    utilities = _ref.utilities;
  const classes = useStyles();
  const statusDotClass = utility => {
    if (utility.isApproved) return classes.utilityRailStatusDotDone;
    // A refused allocation, or one held back over the rise on the last bill, reads the same as dates
    // already billed: something to look at before this utility can go anywhere.
    const needsLookingAt = utility.allocationError || hasOverlappingBills(utility) || isAwaitingSpikeReview(utility);
    return needsLookingAt ? classes.utilityRailStatusDotWarning : '';
  };
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": "Utilities on this bill",
    className: classes.utilityRail,
    role: "tablist"
  }, utilities.map((utility, index) => {
    const isActive = index === activeIndex;
    const label = formatUtilityLabel(utility.serviceType);
    return /*#__PURE__*/React.createElement("button", {
      "aria-label": label,
      "aria-selected": isActive,
      className: "".concat(classes.utilityRailItem, " ").concat(isActive ? classes.utilityRailItemActive : ''),
      key: "".concat(utility.serviceType, "-").concat(index),
      onClick: () => onChange(index),
      role: "tab",
      title: label,
      type: "button"
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.utilityRailIconBox, " ").concat(utility.isApproved ? classes.utilityRailIconBoxDone : '')
    }, /*#__PURE__*/React.createElement(Icon, {
      state: isActive ? 'dark' : 'grey',
      type: getUtilityIconType(utility.serviceType)
    })), showStatus ? /*#__PURE__*/React.createElement("span", {
      className: classes.utilityRailStatus
    }, /*#__PURE__*/React.createElement("span", {
      className: "".concat(classes.utilityRailStatusDot, " ").concat(statusDotClass(utility))
    })) : null);
  }));
}